module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/823870556f0ed6aef8c5d45ccb4e66cf.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Platinum/Platinum4.svg
// module id = ep4t
// module chunks = 1